export default function TimezoneList() {
  return (
    <div
      className="side2"
      id="choose-timezone-list"
      style={{ display: "none" }}
    >
      <table className="timezone">
        <tbody>
          <tr>
            <th>UTC offset</th>
            <th colSpan={2}>Locations that do not use DST</th>
            <th colSpan={2}>Locations that use DST</th>
          </tr>
          <tr>
            <td style={{ width: "5.5em" }}>UTC-12:00</td>
            <td style={{ background: "#00FF85" }}></td>
            <td style={{ maxWidth: "40%" }}>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/23px-Flag_of_the_United_States.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1235"
                    data-file-height="650"
                  />
                  &nbsp;
                </span>
                Baker Island
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/23px-Flag_of_the_United_States.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1235"
                    data-file-height="650"
                  />
                  &nbsp;
                </span>
                Howland Island
              </div>
            </td>
            <td style={{ background: "#00BF63" }}></td>
            <td style={{ maxWidth: "60%" }}></td>
          </tr>
          <tr>
            <td>UTC-11:00</td>
            <td style={{ background: "#F0FF00" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Flag_of_American_Samoa.svg/23px-Flag_of_American_Samoa.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="500"
                  />
                </span>
                &nbsp;American Samoa
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/23px-Flag_of_the_United_States.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1235"
                    data-file-height="650"
                  />
                  &nbsp;
                </span>
                Jarvis Island
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/23px-Flag_of_the_United_States.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1235"
                    data-file-height="650"
                  />
                  &nbsp;
                </span>
                Kingman Reef
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/23px-Flag_of_the_United_States.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1235"
                    data-file-height="650"
                  />
                  &nbsp;
                </span>
                Midway Atoll
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Flag_of_Niue.svg/23px-Flag_of_Niue.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="600"
                    data-file-height="300"
                  />
                </span>
                &nbsp;Niue
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/23px-Flag_of_the_United_States.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1235"
                    data-file-height="650"
                  />
                  &nbsp;
                </span>
                Palmyra Atoll
              </div>
            </td>
            <td style={{ background: "#D3D800" }}></td>
            <td></td>
          </tr>
          <tr>
            <td>UTC-10:00</td>
            <td style={{ background: "#FF409C" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/Flag_of_the_Cook_Islands.svg/23px-Flag_of_the_Cook_Islands.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Cook Islands
                <br />
                <div className="nocolbreak">
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Flag_of_French_Polynesia.svg/23px-Flag_of_French_Polynesia.svg.png"
                      decoding="async"
                      width="23"
                      height="15"
                      className="thumbborder"
                      data-file-width="600"
                      data-file-height="400"
                    />
                    &nbsp;
                  </span>
                  French Polynesia (most)
                </div>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/23px-Flag_of_the_United_States.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1235"
                    data-file-height="650"
                  />
                  &nbsp;
                </span>
                Johnston Atoll
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/23px-Flag_of_the_United_States.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1235"
                    data-file-height="650"
                  />
                </span>
                &nbsp;United States: Hawaii
              </div>
            </td>
            <td style={{ background: "#DE006A" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/23px-Flag_of_the_United_States.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1235"
                  data-file-height="650"
                />
              </span>
              &nbsp;United States: Andreanof Islands, Islands of Four Mountains,
              Near Islands, Rat Islands (Aleutian Islands, Alaska)
            </td>
          </tr>
          <tr>
            <td>UTC-09:30</td>
            <td style={{ background: "#CD61FF" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Flag_of_French_Polynesia.svg/23px-Flag_of_French_Polynesia.svg.png"
                  decoding="async"
                  width="23"
                  height="15"
                  className="thumbborder"
                  data-file-width="600"
                  data-file-height="400"
                />
                &nbsp;
              </span>
              French Polynesia: Marquesas Islands
            </td>
            <td style={{ background: "#9900E0" }}></td>
            <td></td>
          </tr>
          <tr>
            <td>UTC-09:00</td>
            <td style={{ background: "#6D6AFF" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Flag_of_French_Polynesia.svg/23px-Flag_of_French_Polynesia.svg.png"
                  decoding="async"
                  width="23"
                  height="15"
                  className="thumbborder"
                  data-file-width="600"
                  data-file-height="400"
                />
                &nbsp;
              </span>
              French Polynesia: Gambier Islands
            </td>
            <td style={{ background: "#0400CD" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/23px-Flag_of_the_United_States.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1235"
                  data-file-height="650"
                />
              </span>
              &nbsp;United States: Alaska (most)
            </td>
          </tr>
          <tr>
            <td>UTC-08:00</td>
            <td style={{ background: "#00FF85" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/c/c3/Flag_of_France.svg/23px-Flag_of_France.svg.png"
                  decoding="async"
                  width="23"
                  height="15"
                  className="thumbborder"
                  data-file-width="900"
                  data-file-height="600"
                />
                &nbsp;
              </span>
              Clipperton Island
              <br />
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Flag_of_the_Pitcairn_Islands.svg/23px-Flag_of_the_Pitcairn_Islands.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1200"
                  data-file-height="600"
                />
                &nbsp;
              </span>
              Pitcairn Islands
            </td>
            <td style={{ background: "#00BF63" }}></td>
            <td>
              <div style={{columnWidth:'20em',columnCount:2}}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Flag_of_Canada_%28Pantone%29.svg/23px-Flag_of_Canada_%28Pantone%29.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Canada: British Columbia (most)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Flag_of_Mexico.svg/23px-Flag_of_Mexico.svg.png"
                    decoding="async"
                    width="23"
                    height="13"
                    className="thumbborder"
                    data-file-width="980"
                    data-file-height="560"
                  />
                </span>
                &nbsp;Mexico: Baja California
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/23px-Flag_of_the_United_States.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1235"
                    data-file-height="650"
                  />
                </span>
                &nbsp;United States: California, Idaho (north), Nevada (most),
                Oregon (most), Washington
              </div>
            </td>
          </tr>
          <tr>
            <td>UTC-07:00</td>
            <td style={{ background: "#F0FF00" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Flag_of_Canada_%28Pantone%29.svg/23px-Flag_of_Canada_%28Pantone%29.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1200"
                  data-file-height="600"
                />
              </span>
              &nbsp;Canada: British Columbia (northeast), Yukon
              <br />
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Flag_of_Mexico.svg/23px-Flag_of_Mexico.svg.png"
                  decoding="async"
                  width="23"
                  height="13"
                  className="thumbborder"
                  data-file-width="980"
                  data-file-height="560"
                />
              </span>
              &nbsp;Mexico: Baja California Sur, Nayarit (most), Sinaloa, Sonora
              <br />
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/23px-Flag_of_the_United_States.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1235"
                  data-file-height="650"
                />
              </span>
              &nbsp;United States: Arizona (most)
            </td>
            <td style={{ background: "#D3D800" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Flag_of_Canada_%28Pantone%29.svg/23px-Flag_of_Canada_%28Pantone%29.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1200"
                  data-file-height="600"
                />
              </span>
              &nbsp;Canada: Alberta, British Columbia (southeast), Northwest
              Territories, Nunavut (west)
              <br />
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Flag_of_Mexico.svg/23px-Flag_of_Mexico.svg.png"
                  decoding="async"
                  width="23"
                  height="13"
                  className="thumbborder"
                  data-file-width="980"
                  data-file-height="560"
                />
              </span>
              &nbsp;Mexico: Chihuahua (northwest border)
              <br />
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/23px-Flag_of_the_United_States.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1235"
                  data-file-height="650"
                />
              </span>
              &nbsp;United States: Arizona (Navajo Nation), Colorado, Idaho
              (most), Kansas (west), Montana, Nebraska (west), New Mexico,
              Nevada (northeast border), North Dakota (southwest), Oregon
              (east), South Dakota (west), Texas (west), Utah, Wyoming
            </td>
          </tr>
          <tr>
            <td>UTC-06:00</td>
            <td style={{ background: "#FF409C" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Flag_of_Belize.svg/23px-Flag_of_Belize.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Belize
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Flag_of_Canada_%28Pantone%29.svg/23px-Flag_of_Canada_%28Pantone%29.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Canada: Saskatchewan (most)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Flag_of_Costa_Rica.svg/23px-Flag_of_Costa_Rica.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Costa Rica
                <br />
                <link
                  rel="mw-deduplicated-inline-style"
                  href="mw-data:TemplateStyles:r999519993"
                />
                <div className="nocolbreak">
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Flag_of_Ecuador.svg/23px-Flag_of_Ecuador.svg.png"
                      decoding="async"
                      width="23"
                      height="15"
                      className="thumbborder"
                      data-file-width="1440"
                      data-file-height="960"
                    />
                  </span>
                  &nbsp;Ecuador: Galápagos
                </div>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Flag_of_El_Salvador.svg/23px-Flag_of_El_Salvador.svg.png"
                    decoding="async"
                    width="23"
                    height="13"
                    className="thumbborder"
                    data-file-width="1005"
                    data-file-height="567"
                  />
                  &nbsp;
                </span>
                El Salvador
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Flag_of_Guatemala.svg/23px-Flag_of_Guatemala.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="960"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Guatemala
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Flag_of_Honduras.svg/23px-Flag_of_Honduras.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Honduras
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Flag_of_Mexico.svg/23px-Flag_of_Mexico.svg.png"
                    decoding="async"
                    width="23"
                    height="13"
                    className="thumbborder"
                    data-file-width="980"
                    data-file-height="560"
                  />
                </span>
                &nbsp;Mexico (most)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Flag_of_Nicaragua.svg/23px-Flag_of_Nicaragua.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Nicaragua
              </div>
            </td>
            <td style={{ background: "#DE006A" }}></td>
            <td>
              <div style={{columnWidth:'20em',columnCount:2}}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Flag_of_Canada_%28Pantone%29.svg/23px-Flag_of_Canada_%28Pantone%29.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Canada: Manitoba, Nunavut (central), Ontario (west)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Flag_of_Chile.svg/23px-Flag_of_Chile.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Chile: Easter Island
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Flag_of_Mexico.svg/23px-Flag_of_Mexico.svg.png"
                    decoding="async"
                    width="23"
                    height="13"
                    className="thumbborder"
                    data-file-width="980"
                    data-file-height="560"
                  />
                </span>
                &nbsp;Mexico (northeast border)
                <br />
                <link
                  rel="mw-deduplicated-inline-style"
                  href="mw-data:TemplateStyles:r999519993"
                />
                <div className="nocolbreak">
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/23px-Flag_of_the_United_States.svg.png"
                      decoding="async"
                      width="23"
                      height="12"
                      className="thumbborder"
                      data-file-width="1235"
                      data-file-height="650"
                    />
                  </span>
                  &nbsp;United States: Alabama, Arkansas, Florida (northwest),
                  Illinois, Indiana (northwest, southwest), Iowa, Kansas (most),
                  Kentucky (west), Louisiana, Michigan (northwest border),
                  Minnesota, Mississippi, Missouri, Nebraska (most), North
                  Dakota (most), Oklahoma, South Dakota (most), Tennessee
                  (most), Texas (most), Wisconsin
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>UTC-05:00</td>
            <td style={{ background: "#6D6AFF" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/0/05/Flag_of_Brazil.svg/22px-Flag_of_Brazil.svg.png"
                    decoding="async"
                    width="22"
                    height="15"
                    className="thumbborder"
                    data-file-width="720"
                    data-file-height="504"
                  />
                </span>
                &nbsp;Brazil: Acre, Amazonas (southwest)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Flag_of_Canada_%28Pantone%29.svg/23px-Flag_of_Canada_%28Pantone%29.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Canada: Atikokan, Mishkeegogamang, Southampton Island
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Flag_of_the_Cayman_Islands.svg/23px-Flag_of_the_Cayman_Islands.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Cayman Islands
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Flag_of_Colombia.svg/23px-Flag_of_Colombia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Colombia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Flag_of_Ecuador.svg/23px-Flag_of_Ecuador.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="1440"
                    data-file-height="960"
                  />
                </span>
                &nbsp;Ecuador (most)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Flag_of_Jamaica.svg/23px-Flag_of_Jamaica.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Jamaica
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Flag_of_Mexico.svg/23px-Flag_of_Mexico.svg.png"
                    decoding="async"
                    width="23"
                    height="13"
                    className="thumbborder"
                    data-file-width="980"
                    data-file-height="560"
                  />
                </span>
                &nbsp;Mexico: Quintana Roo
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/23px-Flag_of_the_United_States.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1235"
                    data-file-height="650"
                  />
                  &nbsp;
                </span>
                Navassa Island
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/Flag_of_Panama.svg/23px-Flag_of_Panama.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Panama
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Flag_of_Peru.svg/23px-Flag_of_Peru.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Peru
              </div>
            </td>
            <td style={{ background: "#0400CD" }}></td>
            <td>
              <div style={{columnWidth:'20em',columnCount:2}}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Flag_of_the_Bahamas.svg/23px-Flag_of_the_Bahamas.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Bahamas
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Flag_of_Canada_%28Pantone%29.svg/23px-Flag_of_Canada_%28Pantone%29.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Canada: Nunavut (east), Ontario (most), Quebec (most)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Flag_of_Cuba.svg/23px-Flag_of_Cuba.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Cuba
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Flag_of_Haiti.svg/23px-Flag_of_Haiti.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Haiti
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Flag_of_the_Turks_and_Caicos_Islands.svg/23px-Flag_of_the_Turks_and_Caicos_Islands.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Turks and Caicos Islands
                <br />
                <link
                  rel="mw-deduplicated-inline-style"
                  href="mw-data:TemplateStyles:r999519993"
                />
                <div className="nocolbreak">
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/23px-Flag_of_the_United_States.svg.png"
                      decoding="async"
                      width="23"
                      height="12"
                      className="thumbborder"
                      data-file-width="1235"
                      data-file-height="650"
                    />
                  </span>
                  &nbsp;United States: Connecticut, Delaware, District of
                  Columbia, Florida (most), Georgia, Indiana (most), Kentucky
                  (most), Maine, Maryland, Massachusetts, Michigan (most), New
                  Hampshire, New Jersey, New York, North Carolina, Ohio,
                  Pennsylvania, Rhode Island, South Carolina, Tennessee (east),
                  Vermont, Virginia, West Virginia
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>UTC-04:00</td>
            <td style={{ background: "#00FF85" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Flag_of_Anguilla.svg/23px-Flag_of_Anguilla.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Anguilla
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Flag_of_Antigua_and_Barbuda.svg/23px-Flag_of_Antigua_and_Barbuda.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Antigua and Barbuda
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Flag_of_Aruba.svg/23px-Flag_of_Aruba.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Aruba
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Flag_of_Barbados.svg/23px-Flag_of_Barbados.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="1500"
                    data-file-height="1000"
                  />
                  &nbsp;
                </span>
                Barbados
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Bandera_de_Bolivia_%28Estado%29.svg/22px-Bandera_de_Bolivia_%28Estado%29.svg.png"
                    decoding="async"
                    width="22"
                    height="15"
                    className="thumbborder"
                    data-file-width="1100"
                    data-file-height="750"
                  />
                  &nbsp;
                </span>
                Bolivia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/0/05/Flag_of_Brazil.svg/22px-Flag_of_Brazil.svg.png"
                    decoding="async"
                    width="22"
                    height="15"
                    className="thumbborder"
                    data-file-width="720"
                    data-file-height="504"
                  />
                </span>
                &nbsp;Brazil: Amazonas (most), Mato Grosso, Mato Grosso do Sul,
                Rondônia, Roraima
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/Flag_of_the_British_Virgin_Islands.svg/23px-Flag_of_the_British_Virgin_Islands.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                British Virgin Islands
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Flag_of_Canada_%28Pantone%29.svg/23px-Flag_of_Canada_%28Pantone%29.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Canada: Quebec (east)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Flag_of_the_Netherlands.svg/23px-Flag_of_the_Netherlands.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Caribbean Netherlands
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Flag_of_Cura%C3%A7ao.svg/23px-Flag_of_Cura%C3%A7ao.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Curaçao
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Flag_of_Dominica.svg/23px-Flag_of_Dominica.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Dominica
                <br />
                <link
                  rel="mw-deduplicated-inline-style"
                  href="mw-data:TemplateStyles:r999519993"
                />
                <div className="nocolbreak">
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Flag_of_the_Dominican_Republic.svg/23px-Flag_of_the_Dominican_Republic.svg.png"
                      decoding="async"
                      width="23"
                      height="15"
                      className="thumbborder"
                      data-file-width="900"
                      data-file-height="600"
                    />
                    &nbsp;
                  </span>
                  Dominican Republic
                </div>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Flag_of_Grenada.svg/23px-Flag_of_Grenada.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Grenada
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/c/c3/Flag_of_France.svg/23px-Flag_of_France.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Guadeloupe
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Flag_of_Guyana.svg/23px-Flag_of_Guyana.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Guyana
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/c/c3/Flag_of_France.svg/23px-Flag_of_France.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Martinique
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Flag_of_Montserrat.svg/23px-Flag_of_Montserrat.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Montserrat
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Flag_of_Puerto_Rico.svg/23px-Flag_of_Puerto_Rico.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Puerto Rico
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/c/c3/Flag_of_France.svg/23px-Flag_of_France.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Saint Barthélemy
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Flag_of_Saint_Kitts_and_Nevis.svg/23px-Flag_of_Saint_Kitts_and_Nevis.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Saint Kitts and Nevis
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Flag_of_Saint_Lucia.svg/23px-Flag_of_Saint_Lucia.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Saint Lucia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/c/c3/Flag_of_France.svg/23px-Flag_of_France.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Saint Martin
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/Flag_of_Saint_Vincent_and_the_Grenadines.svg/23px-Flag_of_Saint_Vincent_and_the_Grenadines.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Saint Vincent and the Grenadines
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Flag_of_Sint_Maarten.svg/23px-Flag_of_Sint_Maarten.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="675"
                    data-file-height="450"
                  />
                  &nbsp;
                </span>
                Sint Maarten
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Flag_of_Trinidad_and_Tobago.svg/23px-Flag_of_Trinidad_and_Tobago.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="800"
                    data-file-height="480"
                  />
                </span>
                &nbsp;Trinidad and Tobago
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Flag_of_the_United_States_Virgin_Islands.svg/23px-Flag_of_the_United_States_Virgin_Islands.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="1275"
                    data-file-height="850"
                  />
                </span>
                &nbsp;U.S. Virgin Islands
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Flag_of_Venezuela.svg/23px-Flag_of_Venezuela.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Venezuela
              </div>
            </td>
            <td style={{ background: "#00BF63" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/Flag_of_Bermuda.svg/23px-Flag_of_Bermuda.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1000"
                  data-file-height="500"
                />
                &nbsp;
              </span>
              Bermuda
              <br />
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Flag_of_Canada_%28Pantone%29.svg/23px-Flag_of_Canada_%28Pantone%29.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1200"
                  data-file-height="600"
                />
              </span>
              &nbsp;Canada: Labrador (most), New Brunswick, Nova Scotia, Prince
              Edward Island
              <br />
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Flag_of_Chile.svg/23px-Flag_of_Chile.svg.png"
                  decoding="async"
                  width="23"
                  height="15"
                  className="thumbborder"
                  data-file-width="900"
                  data-file-height="600"
                />
              </span>
              &nbsp;Chile (most)
              <br />
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Flag_of_Greenland.svg/23px-Flag_of_Greenland.svg.png"
                  decoding="async"
                  width="23"
                  height="15"
                  className="thumbborder"
                  data-file-width="900"
                  data-file-height="600"
                />
              </span>
              &nbsp;Greenland: Pituffik Space Base
              <br />
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Flag_of_Paraguay.svg/23px-Flag_of_Paraguay.svg.png"
                  decoding="async"
                  width="23"
                  height="13"
                  className="thumbborder"
                  data-file-width="1200"
                  data-file-height="660"
                />
              </span>
              &nbsp;Paraguay
            </td>
          </tr>
          <tr>
            <td>UTC-03:30</td>
            <td style={{ background: "#A9FF13" }}></td>
            <td></td>
            <td style={{ background: "#419300" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Flag_of_Canada_%28Pantone%29.svg/23px-Flag_of_Canada_%28Pantone%29.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1200"
                  data-file-height="600"
                />
              </span>
              &nbsp;Canada: Newfoundland, Labrador (southeast)
            </td>
          </tr>
          <tr>
            <td>UTC-03:00</td>
            <td style={{ background: "#F0FF00" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Flag_of_Argentina.svg/23px-Flag_of_Argentina.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="800"
                    data-file-height="500"
                  />
                </span>
                &nbsp;Argentina
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/0/05/Flag_of_Brazil.svg/22px-Flag_of_Brazil.svg.png"
                    decoding="async"
                    width="22"
                    height="15"
                    className="thumbborder"
                    data-file-width="720"
                    data-file-height="504"
                  />
                </span>
                &nbsp;Brazil (most)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Flag_of_Chile.svg/23px-Flag_of_Chile.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Chile: Magallanes Region
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Flag_of_the_Falkland_Islands.svg/23px-Flag_of_the_Falkland_Islands.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Falkland Islands
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/c/c3/Flag_of_France.svg/23px-Flag_of_France.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                French Guiana
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Flag_of_Suriname.svg/23px-Flag_of_Suriname.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Suriname
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Flag_of_Uruguay.svg/23px-Flag_of_Uruguay.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="945"
                    data-file-height="630"
                  />
                </span>
                &nbsp;Uruguay
              </div>
            </td>
            <td style={{ background: "#D3D800" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/c/c3/Flag_of_France.svg/23px-Flag_of_France.svg.png"
                  decoding="async"
                  width="23"
                  height="15"
                  className="thumbborder"
                  data-file-width="900"
                  data-file-height="600"
                />
                &nbsp;
              </span>
              Saint Pierre and Miquelon
            </td>
          </tr>
          <tr>
            <td>UTC-02:00</td>
            <td style={{ background: "#FF409C" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/0/05/Flag_of_Brazil.svg/22px-Flag_of_Brazil.svg.png"
                    decoding="async"
                    width="22"
                    height="15"
                    className="thumbborder"
                    data-file-width="720"
                    data-file-height="504"
                  />
                </span>
                &nbsp;Brazil: Fernando de Noronha
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Flag_of_Greenland.svg/23px-Flag_of_Greenland.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Greenland (most)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/ed/Flag_of_South_Georgia_and_the_South_Sandwich_Islands.svg/23px-Flag_of_South_Georgia_and_the_South_Sandwich_Islands.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="750"
                    data-file-height="375"
                  />
                  &nbsp;
                </span>
                South Georgia and the South Sandwich Islands
              </div>
            </td>
            <td style={{ background: "#DE006A" }}></td>
            <td></td>
          </tr>
          <tr>
            <td>UTC-01:00</td>
            <td style={{ background: "#6D6AFF" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Flag_of_Cape_Verde.svg/23px-Flag_of_Cape_Verde.svg.png"
                  decoding="async"
                  width="23"
                  height="14"
                  className="thumbborder"
                  data-file-width="1020"
                  data-file-height="600"
                />
              </span>
              &nbsp;Cape Verde
            </td>
            <td style={{ background: "#0400CD" }}></td>
            <td>
              <div style={{columnWidth:'20em',columnCount:2}}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Flag_of_Greenland.svg/23px-Flag_of_Greenland.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Greenland: Ittoqqortoormiit
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Flag_of_Portugal.svg/23px-Flag_of_Portugal.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="600"
                    data-file-height="400"
                  />
                </span>
                &nbsp;Portugal: Azores
              </div>
            </td>
          </tr>
          <tr>
            <td>UTC+00:00</td>
            <td style={{ background: "#00FF85" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Flag_of_Burkina_Faso.svg/23px-Flag_of_Burkina_Faso.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Burkina Faso
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Flag_of_The_Gambia.svg/23px-Flag_of_The_Gambia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Gambia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Flag_of_Ghana.svg/23px-Flag_of_Ghana.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Ghana
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Flag_of_Greenland.svg/23px-Flag_of_Greenland.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Greenland: National Park (east coast)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/ed/Flag_of_Guinea.svg/23px-Flag_of_Guinea.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Guinea
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Flag_of_Guinea-Bissau.svg/23px-Flag_of_Guinea-Bissau.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Guinea-Bissau
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Flag_of_Iceland.svg/21px-Flag_of_Iceland.svg.png"
                    decoding="async"
                    width="21"
                    height="15"
                    className="thumbborder"
                    data-file-width="1250"
                    data-file-height="900"
                  />
                  &nbsp;
                </span>
                Iceland
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Flag_of_C%C3%B4te_d%27Ivoire.svg/23px-Flag_of_C%C3%B4te_d%27Ivoire.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Ivory Coast
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Flag_of_Liberia.svg/23px-Flag_of_Liberia.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1140"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Liberia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Flag_of_Mali.svg/23px-Flag_of_Mali.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Mali
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/Flag_of_Mauritania.svg/23px-Flag_of_Mauritania.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="800"
                  />
                  &nbsp;
                </span>
                Mauritania
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/ae/Flag_of_the_United_Kingdom.svg/23px-Flag_of_the_United_Kingdom.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Saint Helena, Ascension and Tristan da Cunha
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Flag_of_Senegal.svg/23px-Flag_of_Senegal.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Senegal
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Flag_of_Sierra_Leone.svg/23px-Flag_of_Sierra_Leone.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Sierra Leone
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Flag_of_S%C3%A3o_Tom%C3%A9_and_Pr%C3%ADncipe.svg/23px-Flag_of_S%C3%A3o_Tom%C3%A9_and_Pr%C3%ADncipe.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                São Tomé and Príncipe
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/68/Flag_of_Togo.svg/23px-Flag_of_Togo.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="809"
                    data-file-height="500"
                  />
                  &nbsp;
                </span>
                Togo
              </div>
            </td>
            <td style={{ background: "#00BF63" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Flag_of_the_Faroe_Islands.svg/21px-Flag_of_the_Faroe_Islands.svg.png"
                  decoding="async"
                  width="21"
                  height="15"
                  className="thumbborder"
                  data-file-width="1100"
                  data-file-height="800"
                />
              </span>
              &nbsp;Faroe Islands
              <br />
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Flag_of_Guernsey.svg/23px-Flag_of_Guernsey.svg.png"
                  decoding="async"
                  width="23"
                  height="15"
                  className="thumbborder"
                  data-file-width="900"
                  data-file-height="600"
                />
                &nbsp;
              </span>
              Guernsey
              <br />
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Flag_of_Ireland.svg/23px-Flag_of_Ireland.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1200"
                  data-file-height="600"
                />
              </span>
              &nbsp;Ireland
              <br />
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Flag_of_the_Isle_of_Man.svg/23px-Flag_of_the_Isle_of_Man.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="600"
                  data-file-height="300"
                />
                &nbsp;
              </span>
              Isle of Man
              <br />
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/Flag_of_Jersey.svg/23px-Flag_of_Jersey.svg.png"
                  decoding="async"
                  width="23"
                  height="14"
                  className="thumbborder"
                  data-file-width="1000"
                  data-file-height="600"
                />
                &nbsp;
              </span>
              Jersey
              <br />
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Flag_of_Portugal.svg/23px-Flag_of_Portugal.svg.png"
                  decoding="async"
                  width="23"
                  height="15"
                  className="thumbborder"
                  data-file-width="600"
                  data-file-height="400"
                />
              </span>
              &nbsp;Portugal (most)
              <br />
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/9/9a/Flag_of_Spain.svg/23px-Flag_of_Spain.svg.png"
                  decoding="async"
                  width="23"
                  height="15"
                  className="thumbborder"
                  data-file-width="750"
                  data-file-height="500"
                />
              </span>
              &nbsp;Spain: Canary Islands
              <br />
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/ae/Flag_of_the_United_Kingdom.svg/23px-Flag_of_the_United_Kingdom.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1200"
                  data-file-height="600"
                />
              </span>
              &nbsp;United Kingdom
            </td>
          </tr>
          <tr>
            <td>UTC+01:00</td>
            <td style={{ background: "#F0FF00" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Flag_of_Algeria.svg/23px-Flag_of_Algeria.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Algeria
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Flag_of_Angola.svg/23px-Flag_of_Angola.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Angola
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Flag_of_Benin.svg/23px-Flag_of_Benin.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Benin
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Flag_of_Cameroon.svg/23px-Flag_of_Cameroon.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Cameroon
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Flag_of_the_Central_African_Republic.svg/23px-Flag_of_the_Central_African_Republic.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Central African Republic
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Flag_of_Chad.svg/23px-Flag_of_Chad.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Chad
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Flag_of_the_Republic_of_the_Congo.svg/23px-Flag_of_the_Republic_of_the_Congo.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="600"
                    data-file-height="400"
                  />
                  &nbsp;
                </span>
                Congo
                <br />
                <link
                  rel="mw-deduplicated-inline-style"
                  href="mw-data:TemplateStyles:r999519993"
                />
                <div className="nocolbreak">
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Flag_of_the_Democratic_Republic_of_the_Congo.svg/20px-Flag_of_the_Democratic_Republic_of_the_Congo.svg.png"
                      decoding="async"
                      width="20"
                      height="15"
                      className="thumbborder"
                      data-file-width="800"
                      data-file-height="600"
                    />
                  </span>
                  &nbsp;Democratic Republic of the Congo: Équateur, Kinshasa,
                  Kongo Central, Kwango, Kwilu, Mai-Ndombe, Mongala,
                  Nord-Ubangi, Sud-Ubangi, Tshuapa
                </div>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Flag_of_Equatorial_Guinea.svg/23px-Flag_of_Equatorial_Guinea.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="800"
                  />
                  &nbsp;
                </span>
                Equatorial Guinea
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Flag_of_Gabon.svg/20px-Flag_of_Gabon.svg.png"
                    decoding="async"
                    width="20"
                    height="15"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="750"
                  />
                  &nbsp;
                </span>
                Gabon
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Flag_of_Morocco.svg/23px-Flag_of_Morocco.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Morocco
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Flag_of_Niger.svg/18px-Flag_of_Niger.svg.png"
                    decoding="async"
                    width="18"
                    height="15"
                    className="thumbborder"
                    data-file-width="700"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Niger
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Flag_of_Nigeria.svg/23px-Flag_of_Nigeria.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Nigeria
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Flag_of_Tunisia.svg/23px-Flag_of_Tunisia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="800"
                  />
                </span>
                &nbsp;Tunisia
                <br />
                <i>
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/26/Flag_of_the_Sahrawi_Arab_Democratic_Republic.svg/23px-Flag_of_the_Sahrawi_Arab_Democratic_Republic.svg.png"
                      decoding="async"
                      width="23"
                      height="12"
                      className="thumbborder"
                      data-file-width="600"
                      data-file-height="300"
                    />
                    &nbsp;
                  </span>
                  Western Sahara
                </i>
              </div>
            </td>
            <td style={{ background: "#D3D800" }}></td>
            <td>
              <div style={{columnWidth:'10em',columnCount:3}}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Flag_of_Albania.svg/21px-Flag_of_Albania.svg.png"
                    decoding="async"
                    width="21"
                    height="15"
                    className="thumbborder"
                    data-file-width="980"
                    data-file-height="700"
                  />
                  &nbsp;
                </span>
                Albania
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Flag_of_Andorra.svg/22px-Flag_of_Andorra.svg.png"
                    decoding="async"
                    width="22"
                    height="15"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="700"
                  />
                  &nbsp;
                </span>
                Andorra
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Flag_of_Austria.svg/23px-Flag_of_Austria.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Austria
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Flag_of_Belgium_%28civil%29.svg/23px-Flag_of_Belgium_%28civil%29.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Belgium
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/Flag_of_Bosnia_and_Herzegovina.svg/23px-Flag_of_Bosnia_and_Herzegovina.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="800"
                    data-file-height="400"
                  />
                </span>
                &nbsp;Bosnia and Herzegovina
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Flag_of_Croatia.svg/23px-Flag_of_Croatia.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Croatia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Flag_of_the_Czech_Republic.svg/23px-Flag_of_the_Czech_Republic.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Czech Republic
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Flag_of_Denmark.svg/20px-Flag_of_Denmark.svg.png"
                    decoding="async"
                    width="20"
                    height="15"
                    className="thumbborder"
                    data-file-width="512"
                    data-file-height="387"
                  />
                </span>
                &nbsp;Denmark
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/c/c3/Flag_of_France.svg/23px-Flag_of_France.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;France (metropolitan)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/b/ba/Flag_of_Germany.svg/23px-Flag_of_Germany.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Germany
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Flag_of_Gibraltar.svg/23px-Flag_of_Gibraltar.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="500"
                  />
                </span>
                &nbsp;Gibraltar
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Flag_of_Hungary.svg/23px-Flag_of_Hungary.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Hungary
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/0/03/Flag_of_Italy.svg/23px-Flag_of_Italy.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="1500"
                    data-file-height="1000"
                  />
                </span>
                &nbsp;Italy
                <br />
                <i>
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/1f/Flag_of_Kosovo.svg/21px-Flag_of_Kosovo.svg.png"
                      decoding="async"
                      width="21"
                      height="15"
                      className="thumbborder"
                      data-file-width="840"
                      data-file-height="600"
                    />
                    &nbsp;
                  </span>
                  Kosovo
                </i>
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/Flag_of_Liechtenstein.svg/23px-Flag_of_Liechtenstein.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Liechtenstein
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Flag_of_Luxembourg.svg/23px-Flag_of_Luxembourg.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Luxembourg
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Flag_of_Malta.svg/23px-Flag_of_Malta.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Malta
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Flag_of_Monaco.svg/19px-Flag_of_Monaco.svg.png"
                    decoding="async"
                    width="19"
                    height="15"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="800"
                  />
                  &nbsp;
                </span>
                Monaco
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Flag_of_Montenegro.svg/23px-Flag_of_Montenegro.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Montenegro
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Flag_of_the_Netherlands.svg/23px-Flag_of_the_Netherlands.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Netherlands (European)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Flag_of_North_Macedonia.svg/23px-Flag_of_North_Macedonia.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                North Macedonia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Flag_of_Norway.svg/21px-Flag_of_Norway.svg.png"
                    decoding="async"
                    width="21"
                    height="15"
                    className="thumbborder"
                    data-file-width="512"
                    data-file-height="372"
                  />
                </span>
                &nbsp;Norway
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/1/12/Flag_of_Poland.svg/23px-Flag_of_Poland.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1280"
                    data-file-height="800"
                  />
                  &nbsp;
                </span>
                Poland
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Flag_of_San_Marino.svg/20px-Flag_of_San_Marino.svg.png"
                    decoding="async"
                    width="20"
                    height="15"
                    className="thumbborder"
                    data-file-width="800"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                San Marino
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/ff/Flag_of_Serbia.svg/23px-Flag_of_Serbia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="945"
                    data-file-height="630"
                  />
                  &nbsp;
                </span>
                Serbia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Flag_of_Slovakia.svg/23px-Flag_of_Slovakia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Slovakia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Flag_of_Slovenia.svg/23px-Flag_of_Slovenia.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Slovenia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/9/9a/Flag_of_Spain.svg/23px-Flag_of_Spain.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="750"
                    data-file-height="500"
                  />
                </span>
                &nbsp;Spain (most)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/4/4c/Flag_of_Sweden.svg/23px-Flag_of_Sweden.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1600"
                    data-file-height="1000"
                  />
                  &nbsp;
                </span>
                Sweden
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Flag_of_Switzerland_%28Pantone%29.svg/15px-Flag_of_Switzerland_%28Pantone%29.svg.png"
                    decoding="async"
                    width="15"
                    height="15"
                    className="thumbborder"
                    data-file-width="512"
                    data-file-height="512"
                  />
                </span>
                &nbsp;Switzerland
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/Flag_of_the_Vatican_City_%282023%E2%80%93present%29.svg/16px-Flag_of_the_Vatican_City_%282023%E2%80%93present%29.svg.png"
                    decoding="async"
                    width="16"
                    height="16"
                    className="mw-file-element"
                    data-file-width="1000"
                    data-file-height="1000"
                  />
                </span>
                &nbsp;Vatican City
              </div>
            </td>
          </tr>
          <tr>
            <td>UTC+02:00</td>
            <td style={{ background: "#FF409C" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Flag_of_Botswana.svg/23px-Flag_of_Botswana.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="800"
                  />
                  &nbsp;
                </span>
                Botswana
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Flag_of_Burundi.svg/23px-Flag_of_Burundi.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Burundi
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Flag_of_the_Democratic_Republic_of_the_Congo.svg/20px-Flag_of_the_Democratic_Republic_of_the_Congo.svg.png"
                    decoding="async"
                    width="20"
                    height="15"
                    className="thumbborder"
                    data-file-width="800"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Democratic Republic of the Congo (most)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Flag_of_Eswatini.svg/23px-Flag_of_Eswatini.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Eswatini
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Flag_of_Lesotho.svg/23px-Flag_of_Lesotho.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Lesotho
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Flag_of_Libya.svg/23px-Flag_of_Libya.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="960"
                    data-file-height="480"
                  />
                  &nbsp;
                </span>
                Libya
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Flag_of_Malawi.svg/23px-Flag_of_Malawi.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Malawi
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Flag_of_Mozambique.svg/23px-Flag_of_Mozambique.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Mozambique
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Flag_of_Namibia.svg/23px-Flag_of_Namibia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Namibia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/f/f3/Flag_of_Russia.svg/23px-Flag_of_Russia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Russia: Kaliningrad
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Flag_of_Rwanda.svg/23px-Flag_of_Rwanda.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Rwanda
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Flag_of_South_Africa.svg/23px-Flag_of_South_Africa.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;South Africa (most)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Flag_of_South_Sudan.svg/23px-Flag_of_South_Sudan.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                South Sudan
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Flag_of_Sudan.svg/23px-Flag_of_Sudan.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Sudan
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Flag_of_Zambia.svg/23px-Flag_of_Zambia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Zambia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/Flag_of_Zimbabwe.svg/23px-Flag_of_Zimbabwe.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Zimbabwe
              </div>
            </td>
            <td style={{ background: "#DE006A" }}></td>
            <td>
              <div style={{columnWidth:'10em',columnCount:3}}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/ae/Flag_of_the_United_Kingdom.svg/23px-Flag_of_the_United_Kingdom.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Akrotiri and Dhekelia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Flag_of_Bulgaria.svg/23px-Flag_of_Bulgaria.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Bulgaria
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Flag_of_Cyprus.svg/23px-Flag_of_Cyprus.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Cyprus
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Flag_of_Egypt.svg/23px-Flag_of_Egypt.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Egypt
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Flag_of_Estonia.svg/23px-Flag_of_Estonia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="990"
                    data-file-height="630"
                  />
                </span>
                &nbsp;Estonia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Flag_of_Finland.svg/23px-Flag_of_Finland.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1800"
                    data-file-height="1100"
                  />
                </span>
                &nbsp;Finland
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Flag_of_Greece.svg/23px-Flag_of_Greece.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="600"
                    data-file-height="400"
                  />
                  &nbsp;
                </span>
                Greece
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Flag_of_Israel.svg/21px-Flag_of_Israel.svg.png"
                    decoding="async"
                    width="21"
                    height="15"
                    className="thumbborder"
                    data-file-width="1100"
                    data-file-height="800"
                  />
                </span>
                &nbsp;Israel
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Flag_of_Latvia.svg/23px-Flag_of_Latvia.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Latvia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Flag_of_Lebanon.svg/23px-Flag_of_Lebanon.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Lebanon
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/11/Flag_of_Lithuania.svg/23px-Flag_of_Lithuania.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Lithuania
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Flag_of_Moldova.svg/23px-Flag_of_Moldova.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1800"
                    data-file-height="900"
                  />
                  &nbsp;
                </span>
                Moldova
                <br />
                <i>
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/Flag_of_the_Turkish_Republic_of_Northern_Cyprus.svg/23px-Flag_of_the_Turkish_Republic_of_Northern_Cyprus.svg.png"
                      decoding="async"
                      width="23"
                      height="15"
                      className="thumbborder"
                      data-file-width="900"
                      data-file-height="600"
                    />
                    &nbsp;
                  </span>
                  Northern Cyprus
                </i>
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Flag_of_Palestine.svg/23px-Flag_of_Palestine.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="432"
                    data-file-height="216"
                  />
                </span>
                &nbsp;Palestine
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Flag_of_Romania.svg/23px-Flag_of_Romania.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="600"
                    data-file-height="400"
                  />
                  &nbsp;
                </span>
                Romania
                <br />
                <i>
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Flag_of_Transnistria_%28state%29.svg/23px-Flag_of_Transnistria_%28state%29.svg.png"
                      decoding="async"
                      width="23"
                      height="12"
                      className="thumbborder"
                      data-file-width="1200"
                      data-file-height="600"
                    />
                    &nbsp;
                  </span>
                  Transnistria
                </i>
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Flag_of_Ukraine.svg/23px-Flag_of_Ukraine.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="800"
                  />
                </span>
                &nbsp;Ukraine (most)
              </div>
            </td>
          </tr>
          <tr>
            <td>UTC+03:00</td>
            <td style={{ background: "#6D6AFF" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <i>
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Flag_of_the_Republic_of_Abkhazia.svg/23px-Flag_of_the_Republic_of_Abkhazia.svg.png"
                      decoding="async"
                      width="23"
                      height="12"
                      className="thumbborder"
                      data-file-width="600"
                      data-file-height="300"
                    />
                    &nbsp;
                  </span>
                  Abkhazia
                </i>
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Flag_of_Bahrain.svg/23px-Flag_of_Bahrain.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Bahrain
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Flag_of_Belarus.svg/23px-Flag_of_Belarus.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Belarus
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/94/Flag_of_the_Comoros.svg/23px-Flag_of_the_Comoros.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Comoros
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Flag_of_Djibouti.svg/23px-Flag_of_Djibouti.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Djibouti
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Flag_of_Eritrea.svg/23px-Flag_of_Eritrea.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Eritrea
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/71/Flag_of_Ethiopia.svg/23px-Flag_of_Ethiopia.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Ethiopia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Flag_of_the_French_Southern_and_Antarctic_Lands.svg/23px-Flag_of_the_French_Southern_and_Antarctic_Lands.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                French Southern and Antarctic Lands: Scattered Islands
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Flag_of_Iraq.svg/23px-Flag_of_Iraq.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Iraq
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Flag_of_Jordan.svg/23px-Flag_of_Jordan.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Jordan
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Flag_of_Kenya.svg/23px-Flag_of_Kenya.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Kenya
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Flag_of_Kuwait.svg/23px-Flag_of_Kuwait.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Kuwait
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Flag_of_Madagascar.svg/23px-Flag_of_Madagascar.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Madagascar
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/c/c3/Flag_of_France.svg/23px-Flag_of_France.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Mayotte
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/Flag_of_Qatar.svg/23px-Flag_of_Qatar.svg.png"
                    decoding="async"
                    width="23"
                    height="9"
                    className="thumbborder"
                    data-file-width="1400"
                    data-file-height="550"
                  />
                </span>
                &nbsp;Qatar
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/f/f3/Flag_of_Russia.svg/23px-Flag_of_Russia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Russia (most of European part)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/0d/Flag_of_Saudi_Arabia.svg/23px-Flag_of_Saudi_Arabia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Saudi Arabia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Flag_of_Somalia.svg/23px-Flag_of_Somalia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Somalia
                <br />
                <i>
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/Flag_of_Somaliland.svg/23px-Flag_of_Somaliland.svg.png"
                      decoding="async"
                      width="23"
                      height="12"
                      className="thumbborder"
                      data-file-width="1200"
                      data-file-height="600"
                    />
                    &nbsp;
                  </span>
                  Somaliland
                </i>
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Flag_of_South_Africa.svg/23px-Flag_of_South_Africa.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;South Africa: Prince Edward Islands
                <br />
                <i>
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Flag_of_South_Ossetia.svg/23px-Flag_of_South_Ossetia.svg.png"
                      decoding="async"
                      width="23"
                      height="12"
                      className="thumbborder"
                      data-file-width="1200"
                      data-file-height="600"
                    />
                  </span>
                  &nbsp;South Ossetia
                </i>
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Flag_of_Syria.svg/23px-Flag_of_Syria.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Syria
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Flag_of_Tanzania.svg/23px-Flag_of_Tanzania.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Tanzania
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Flag_of_Turkey.svg/23px-Flag_of_Turkey.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="800"
                  />
                </span>
                &nbsp;Turkey
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Flag_of_Uganda.svg/23px-Flag_of_Uganda.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Uganda
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Flag_of_Ukraine.svg/23px-Flag_of_Ukraine.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="800"
                  />
                  &nbsp;
                </span>
                Ukraine: occupied territories
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Flag_of_Yemen.svg/23px-Flag_of_Yemen.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Yemen
              </div>
            </td>
            <td style={{ background: "#0400CD" }}></td>
            <td></td>
          </tr>
          <tr>
            <td>UTC+03:30</td>
            <td style={{ background: "#35C8FF" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Flag_of_Iran.svg/23px-Flag_of_Iran.svg.png"
                  decoding="async"
                  width="23"
                  height="13"
                  className="thumbborder"
                  data-file-width="630"
                  data-file-height="360"
                />
              </span>
              &nbsp;Iran
            </td>
            <td style={{ background: "#0080B2" }}></td>
            <td></td>
          </tr>
          <tr>
            <td>UTC+04:00</td>
            <td style={{ background: "#00FF85" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Flag_of_Armenia.svg/23px-Flag_of_Armenia.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Armenia
                <br />
                <i>
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Flag_of_Artsakh.svg/23px-Flag_of_Artsakh.svg.png"
                      decoding="async"
                      width="23"
                      height="12"
                      className="thumbborder"
                      data-file-width="1200"
                      data-file-height="600"
                    />
                    &nbsp;
                  </span>
                  Artsakh
                </i>
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Flag_of_Azerbaijan.svg/23px-Flag_of_Azerbaijan.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Azerbaijan
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Flag_of_the_French_Southern_and_Antarctic_Lands.svg/23px-Flag_of_the_French_Southern_and_Antarctic_Lands.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                French Southern and Antarctic Lands: Crozet Islands
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Flag_of_Georgia.svg/23px-Flag_of_Georgia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Georgia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Flag_of_Mauritius.svg/23px-Flag_of_Mauritius.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Mauritius
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Flag_of_Oman.svg/23px-Flag_of_Oman.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Oman
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/f/f3/Flag_of_Russia.svg/23px-Flag_of_Russia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Russia: Astrakhan, Samara, Saratov, Udmurtia, Ulyanovsk
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/c/c3/Flag_of_France.svg/23px-Flag_of_France.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Réunion
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Flag_of_Seychelles.svg/23px-Flag_of_Seychelles.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Seychelles
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Flag_of_the_United_Arab_Emirates.svg/23px-Flag_of_the_United_Arab_Emirates.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;United Arab Emirates
              </div>
            </td>
            <td style={{ background: "#00BF63" }}></td>
            <td></td>
          </tr>
          <tr>
            <td>UTC+04:30</td>
            <td style={{ background: "#A9FF13" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Flag_of_the_Taliban.svg/23px-Flag_of_the_Taliban.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1000"
                  data-file-height="500"
                />
              </span>
              &nbsp;Afghanistan
            </td>
            <td style={{ background: "#419300" }}></td>
            <td></td>
          </tr>
          <tr>
            <td>UTC+05:00</td>
            <td style={{ background: "#F0FF00" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Flag_of_the_French_Southern_and_Antarctic_Lands.svg/23px-Flag_of_the_French_Southern_and_Antarctic_Lands.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                French Southern and Antarctic Lands: Kerguelen Islands, Saint
                Paul Island, Amsterdam Island
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Flag_of_Australia_%28converted%29.svg/23px-Flag_of_Australia_%28converted%29.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1280"
                    data-file-height="640"
                  />
                  &nbsp;
                </span>
                Heard Island and McDonald Islands
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Flag_of_Kazakhstan.svg/23px-Flag_of_Kazakhstan.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="500"
                  />
                </span>
                &nbsp;Kazakhstan: Aktobe, Atyrau, Baikonur, Kyzylorda,
                Mangystau, West Kazakhstan
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Flag_of_Maldives.svg/23px-Flag_of_Maldives.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="720"
                    data-file-height="480"
                  />
                </span>
                &nbsp;Maldives
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Flag_of_Pakistan.svg/23px-Flag_of_Pakistan.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Pakistan
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/f/f3/Flag_of_Russia.svg/23px-Flag_of_Russia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Russia: Bashkortostan, Chelyabinsk, Khanty-Mansi, Kurgan,
                Orenburg, Perm, Sverdlovsk, Tyumen, Yamalia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Flag_of_Tajikistan.svg/23px-Flag_of_Tajikistan.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Tajikistan
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Flag_of_Turkmenistan.svg/23px-Flag_of_Turkmenistan.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Turkmenistan
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Flag_of_Uzbekistan.svg/23px-Flag_of_Uzbekistan.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="500"
                  />
                </span>
                &nbsp;Uzbekistan
              </div>
            </td>
            <td style={{ background: "#D3D800" }}></td>
            <td></td>
          </tr>
          <tr>
            <td>UTC+05:30</td>
            <td style={{ background: "#FF9F25" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/4/41/Flag_of_India.svg/23px-Flag_of_India.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="1350"
                    data-file-height="900"
                  />
                </span>
                &nbsp;India
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/11/Flag_of_Sri_Lanka.svg/23px-Flag_of_Sri_Lanka.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Sri Lanka
              </div>
            </td>
            <td style={{ background: "#F05F00" }}></td>
            <td></td>
          </tr>
          <tr>
            <td>UTC+05:45</td>
            <td style={{ background: "#FF2F2F" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9b/Flag_of_Nepal.svg/12px-Flag_of_Nepal.svg.png"
                  decoding="async"
                  width="12"
                  height="15"
                  data-file-width="726"
                  data-file-height="885"
                />
              </span>
              &nbsp;Nepal
            </td>
            <td style={{ background: "#D0D0D0" }}></td>
            <td></td>
          </tr>
          <tr>
            <td>UTC+06:00</td>
            <td style={{ background: "#FF409C" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Flag_of_Bangladesh.svg/23px-Flag_of_Bangladesh.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Bangladesh
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Flag_of_Bhutan.svg/23px-Flag_of_Bhutan.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Bhutan
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/Flag_of_the_Commissioner_of_the_British_Indian_Ocean_Territory.svg/23px-Flag_of_the_Commissioner_of_the_British_Indian_Ocean_Territory.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="600"
                    data-file-height="300"
                  />
                  &nbsp;
                </span>
                British Indian Ocean Territory
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Flag_of_Kazakhstan.svg/23px-Flag_of_Kazakhstan.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="500"
                  />
                </span>
                &nbsp;Kazakhstan (most)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/Flag_of_Kyrgyzstan.svg/23px-Flag_of_Kyrgyzstan.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Kyrgyzstan
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/f/f3/Flag_of_Russia.svg/23px-Flag_of_Russia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Russia: Omsk
              </div>
            </td>
            <td style={{ background: "#DE006A" }}></td>
            <td></td>
          </tr>
          <tr>
            <td>UTC+06:30</td>
            <td style={{ background: "#CD61FF" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Flag_of_the_Cocos_%28Keeling%29_Islands.svg/23px-Flag_of_the_Cocos_%28Keeling%29_Islands.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="600"
                    data-file-height="300"
                  />
                  &nbsp;
                </span>
                Cocos Islands
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/8c/Flag_of_Myanmar.svg/23px-Flag_of_Myanmar.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="800"
                  />
                </span>
                &nbsp;Myanmar
              </div>
            </td>
            <td style={{ background: "#9900E0" }}></td>
            <td></td>
          </tr>
          <tr>
            <td>UTC+07:00</td>
            <td style={{ background: "#6D6AFF" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Flag_of_Cambodia.svg/23px-Flag_of_Cambodia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="640"
                  />
                </span>
                &nbsp;Cambodia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/Flag_of_Christmas_Island.svg/23px-Flag_of_Christmas_Island.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1000"
                    data-file-height="500"
                  />
                  &nbsp;
                </span>
                Christmas Island
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Flag_of_Indonesia.svg/23px-Flag_of_Indonesia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Indonesia: Sumatra, Java, West Kalimantan, Central
                Kalimantan
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Flag_of_Laos.svg/23px-Flag_of_Laos.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Laos
                <br />
                <link
                  rel="mw-deduplicated-inline-style"
                  href="mw-data:TemplateStyles:r999519993"
                />
                <div className="nocolbreak">
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Flag_of_Mongolia.svg/23px-Flag_of_Mongolia.svg.png"
                      decoding="async"
                      width="23"
                      height="12"
                      className="thumbborder"
                      data-file-width="1200"
                      data-file-height="600"
                    />
                  </span>
                  &nbsp;Mongolia: Bayan-Ölgii, Khovd, Uvs
                </div>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/f/f3/Flag_of_Russia.svg/23px-Flag_of_Russia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Russia: Altai Krai, Altai Republic, Kemerovo, Khakassia,
                Krasnoyarsk, Novosibirsk, Tomsk, Tuva
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Flag_of_Thailand.svg/23px-Flag_of_Thailand.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Thailand
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Flag_of_Vietnam.svg/23px-Flag_of_Vietnam.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Vietnam
              </div>
            </td>
            <td style={{ background: "#0400CD" }}></td>
            <td></td>
          </tr>
          <tr>
            <td>UTC+08:00</td>
            <td style={{ background: "#00FF85" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Flag_of_Australia_%28converted%29.svg/23px-Flag_of_Australia_%28converted%29.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1280"
                    data-file-height="640"
                  />
                </span>
                &nbsp;Australia: Western Australia (most)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Flag_of_Brunei.svg/23px-Flag_of_Brunei.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1440"
                    data-file-height="720"
                  />
                </span>
                &nbsp;Brunei
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Flag_of_the_People%27s_Republic_of_China.svg/23px-Flag_of_the_People%27s_Republic_of_China.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;China
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5b/Flag_of_Hong_Kong.svg/23px-Flag_of_Hong_Kong.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Hong Kong
                <br />
                <link
                  rel="mw-deduplicated-inline-style"
                  href="mw-data:TemplateStyles:r999519993"
                />
                <div className="nocolbreak">
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Flag_of_Indonesia.svg/23px-Flag_of_Indonesia.svg.png"
                      decoding="async"
                      width="23"
                      height="15"
                      className="thumbborder"
                      data-file-width="900"
                      data-file-height="600"
                    />
                  </span>
                  &nbsp;Indonesia: South Kalimantan, East Kalimantan, North
                  Kalimantan, Sulawesi, Lesser Sunda Islands
                </div>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Flag_of_Macau.svg/23px-Flag_of_Macau.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Macau
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Flag_of_Malaysia.svg/23px-Flag_of_Malaysia.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Malaysia
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Flag_of_Mongolia.svg/23px-Flag_of_Mongolia.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Mongolia (most)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Flag_of_the_Philippines.svg/23px-Flag_of_the_Philippines.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Philippines
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/f/f3/Flag_of_Russia.svg/23px-Flag_of_Russia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Russia: Buryatia, Irkutsk
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Flag_of_Singapore.svg/23px-Flag_of_Singapore.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Singapore
                <br />
                <i>
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/72/Flag_of_the_Republic_of_China.svg/23px-Flag_of_the_Republic_of_China.svg.png"
                      decoding="async"
                      width="23"
                      height="15"
                      className="thumbborder"
                      data-file-width="900"
                      data-file-height="600"
                    />
                  </span>
                  &nbsp;Taiwan
                </i>
              </div>
            </td>
            <td style={{ background: "#00BF63" }}></td>
            <td></td>
          </tr>
          <tr>
            <td>UTC+08:45</td>
            <td style={{ background: "#A5FB00" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Flag_of_Australia_%28converted%29.svg/23px-Flag_of_Australia_%28converted%29.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1280"
                  data-file-height="640"
                />
              </span>
              &nbsp;Australia: Eucla
            </td>
            <td style={{ background: "#8ED800" }}></td>
            <td></td>
          </tr>
          <tr>
            <td>UTC+09:00</td>
            <td style={{ background: "#F0FF00" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/26/Flag_of_East_Timor.svg/23px-Flag_of_East_Timor.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;East Timor
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Flag_of_Indonesia.svg/23px-Flag_of_Indonesia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Indonesia: Maluku Islands, Western New Guinea
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/9/9e/Flag_of_Japan.svg/23px-Flag_of_Japan.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Japan
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Flag_of_North_Korea.svg/23px-Flag_of_North_Korea.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1600"
                    data-file-height="800"
                  />
                </span>
                &nbsp;North Korea (북한)
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Flag_of_Palau.svg/23px-Flag_of_Palau.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="800"
                    data-file-height="500"
                  />
                  &nbsp;
                </span>
                Palau
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/f/f3/Flag_of_Russia.svg/23px-Flag_of_Russia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Russia: Amur, Sakha (most), Zabaykalsky
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Flag_of_South_Korea.svg/23px-Flag_of_South_Korea.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;South Korea (대한민국/남한)
              </div>
            </td>
            <td style={{ background: "#D3D800" }}></td>
            <td></td>
          </tr>
          <tr>
            <td>UTC+09:30</td>
            <td style={{ background: "#FF9F25" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Flag_of_Australia_%28converted%29.svg/23px-Flag_of_Australia_%28converted%29.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1280"
                  data-file-height="640"
                />
              </span>
              &nbsp;Australia: Northern Territory
            </td>
            <td style={{ background: "#F05F00" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Flag_of_Australia_%28converted%29.svg/23px-Flag_of_Australia_%28converted%29.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1280"
                  data-file-height="640"
                />
              </span>
              &nbsp;Australia: South Australia
            </td>
          </tr>
          <tr>
            <td>UTC+10:00</td>
            <td style={{ background: "#FF409C" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Flag_of_Australia_%28converted%29.svg/23px-Flag_of_Australia_%28converted%29.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1280"
                    data-file-height="640"
                  />
                </span>
                &nbsp;Australia: Queensland
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Flag_of_Guam.svg/23px-Flag_of_Guam.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="7380"
                    data-file-height="3960"
                  />
                </span>
                &nbsp;Guam
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Flag_of_the_Federated_States_of_Micronesia.svg/23px-Flag_of_the_Federated_States_of_Micronesia.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="760"
                    data-file-height="400"
                  />
                  &nbsp;
                </span>
                Micronesia: Chuuk, Yap
                <br />
                <link
                  rel="mw-deduplicated-inline-style"
                  href="mw-data:TemplateStyles:r999519993"
                />
                <div className="nocolbreak">
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Flag_of_the_Northern_Mariana_Islands.svg/23px-Flag_of_the_Northern_Mariana_Islands.svg.png"
                      decoding="async"
                      width="23"
                      height="12"
                      className="thumbborder"
                      data-file-width="1100"
                      data-file-height="550"
                    />
                  </span>
                  &nbsp;Northern Mariana Islands
                </div>
                <link
                  rel="mw-deduplicated-inline-style"
                  href="mw-data:TemplateStyles:r999519993"
                />
                <div className="nocolbreak">
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Flag_of_Papua_New_Guinea.svg/20px-Flag_of_Papua_New_Guinea.svg.png"
                      decoding="async"
                      width="20"
                      height="15"
                      className="thumbborder"
                      data-file-width="600"
                      data-file-height="450"
                    />
                    &nbsp;
                  </span>
                  Papua New Guinea (most)
                </div>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/f/f3/Flag_of_Russia.svg/23px-Flag_of_Russia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Russia: Jewish, Khabarovsk, Primorsky, Sakha
                (central-east)
              </div>
            </td>
            <td style={{ background: "#DE006A" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Flag_of_Australia_%28converted%29.svg/23px-Flag_of_Australia_%28converted%29.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1280"
                  data-file-height="640"
                />
              </span>
              &nbsp;Australia: Australian Capital Territory, Jervis Bay
              Territory, New South Wales (most), Tasmania, Victoria
            </td>
          </tr>
          <tr>
            <td>UTC+10:30</td>
            <td style={{ background: "#CD61FF" }}></td>
            <td></td>
            <td style={{ background: "#9900E0" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Flag_of_Australia_%28converted%29.svg/23px-Flag_of_Australia_%28converted%29.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1280"
                  data-file-height="640"
                />
              </span>
              &nbsp;Australia: Lord Howe Island
            </td>
          </tr>
          <tr>
            <td>UTC+11:00</td>
            <td style={{ background: "#6D6AFF" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Flag_of_the_Federated_States_of_Micronesia.svg/23px-Flag_of_the_Federated_States_of_Micronesia.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="760"
                    data-file-height="400"
                  />
                  &nbsp;
                </span>
                Micronesia: Kosrae, Pohnpei
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/26/Flags_of_New_Caledonia.svg/43px-Flags_of_New_Caledonia.svg.png"
                    decoding="async"
                    width="43"
                    height="12"
                    className="thumbborder"
                    data-file-width="1091"
                    data-file-height="308"
                  />
                  &nbsp;
                </span>
                New Caledonia
                <br />
                <link
                  rel="mw-deduplicated-inline-style"
                  href="mw-data:TemplateStyles:r999519993"
                />
                <div className="nocolbreak">
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Flag_of_Papua_New_Guinea.svg/20px-Flag_of_Papua_New_Guinea.svg.png"
                      decoding="async"
                      width="20"
                      height="15"
                      className="thumbborder"
                      data-file-width="600"
                      data-file-height="450"
                    />
                    &nbsp;
                  </span>
                  Papua New Guinea: Bougainville
                </div>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/f/f3/Flag_of_Russia.svg/23px-Flag_of_Russia.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Russia: Magadan, Sakha (east), Sakhalin
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Flag_of_the_Solomon_Islands.svg/23px-Flag_of_the_Solomon_Islands.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Solomon Islands
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Flag_of_Vanuatu.svg/23px-Flag_of_Vanuatu.svg.png"
                    decoding="async"
                    width="23"
                    height="14"
                    className="thumbborder"
                    data-file-width="600"
                    data-file-height="360"
                  />
                </span>
                &nbsp;Vanuatu
              </div>
            </td>
            <td style={{ background: "#0400CD" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Flag_of_Norfolk_Island.svg/23px-Flag_of_Norfolk_Island.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="920"
                  data-file-height="460"
                />
              </span>
              &nbsp;Norfolk Island
            </td>
          </tr>
          <tr>
            <td>UTC+12:00</td>
            <td style={{ background: "#00FF85" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Flag_of_Fiji.svg/23px-Flag_of_Fiji.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Fiji
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Flag_of_Kiribati.svg/23px-Flag_of_Kiribati.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Kiribati: Gilbert Islands
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/Flag_of_the_Marshall_Islands.svg/23px-Flag_of_the_Marshall_Islands.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1140"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Marshall Islands
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/Flag_of_Nauru.svg/23px-Flag_of_Nauru.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="600"
                    data-file-height="300"
                  />
                  &nbsp;
                </span>
                Nauru
                <br />
                <link
                  rel="mw-deduplicated-inline-style"
                  href="mw-data:TemplateStyles:r999519993"
                />
                <div className="nocolbreak">
                  <span className="flagicon">
                    <img
                      delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/f/f3/Flag_of_Russia.svg/23px-Flag_of_Russia.svg.png"
                      decoding="async"
                      width="23"
                      height="15"
                      className="thumbborder"
                      data-file-width="900"
                      data-file-height="600"
                    />
                  </span>
                  &nbsp;Russia: Chukotka, Kamchatka
                </div>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Flag_of_Tuvalu.svg/23px-Flag_of_Tuvalu.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Tuvalu
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/23px-Flag_of_the_United_States.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1235"
                    data-file-height="650"
                  />
                  &nbsp;
                </span>
                Wake Island
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/en/thumb/c/c3/Flag_of_France.svg/23px-Flag_of_France.svg.png"
                    decoding="async"
                    width="23"
                    height="15"
                    className="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Wallis and Futuna
              </div>
            </td>
            <td style={{ background: "#00BF63" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Flag_of_New_Zealand.svg/23px-Flag_of_New_Zealand.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1200"
                  data-file-height="600"
                />
              </span>
              &nbsp;New Zealand (most)
            </td>
          </tr>
          <tr>
            <td>UTC+12:45</td>
            <td style={{ background: "#A5FB00" }}></td>
            <td></td>
            <td style={{ background: "#8ED800" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Flag_of_New_Zealand.svg/23px-Flag_of_New_Zealand.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1200"
                  data-file-height="600"
                />
              </span>
              &nbsp;New Zealand: Chatham Islands
            </td>
          </tr>
          <tr>
            <td>UTC+13:00</td>
            <td style={{ background: "#F0FF00" }}></td>
            <td>
              <div style={{ columnWidth: "10em", columnCount: 2 }}>
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Flag_of_Kiribati.svg/23px-Flag_of_Kiribati.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                  &nbsp;
                </span>
                Kiribati: Phoenix Islands
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Flag_of_Samoa.svg/23px-Flag_of_Samoa.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1200"
                    data-file-height="600"
                  />
                </span>
                &nbsp;Samoa
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Flag_of_Tokelau.svg/23px-Flag_of_Tokelau.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="1800"
                    data-file-height="900"
                  />
                </span>
                &nbsp;Tokelau
                <br />
                <span className="flagicon">
                  <img
                    delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Flag_of_Tonga.svg/23px-Flag_of_Tonga.svg.png"
                    decoding="async"
                    width="23"
                    height="12"
                    className="thumbborder"
                    data-file-width="960"
                    data-file-height="480"
                  />
                </span>
                &nbsp;Tonga
              </div>
            </td>
            <td style={{ background: "#D3D800" }}></td>
            <td></td>
          </tr>
          <tr>
            <td>UTC+14:00</td>
            <td style={{ background: "#FF409C" }}></td>
            <td>
              <span className="flagicon">
                <img
                  delayed-src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Flag_of_Kiribati.svg/23px-Flag_of_Kiribati.svg.png"
                  decoding="async"
                  width="23"
                  height="12"
                  className="thumbborder"
                  data-file-width="1200"
                  data-file-height="600"
                />
                &nbsp;
              </span>
              Kiribati: Line Islands
            </td>
            <td style={{ background: "#DE006A" }}></td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <div className="cBoth"></div>
    </div>
  );
}
